// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { auth } from "firebaseui";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB42GOq551iy6byfCcii0nvSHJ_A-RwMOg",
  authDomain: "tik-tech-job.firebaseapp.com",
  projectId: "tik-tech-job",
  storageBucket: "tik-tech-job.appspot.com",
  messagingSenderId: "922822222630",
  appId: "1:922822222630:web:b92f501ac8195773f957e7",
  measurementId: "G-EL78KYF5PZ"
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);

export const firebaseUI = new auth.AuthUI(getAuth(firebaseApp)); //eslint-disable-line